import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import Login from './pages/Login';
import OrderPage from './pages/OrderPage';
import ShopRegistration from './pages/ShopRegistration';
import ShopDashboard from './pages/ShopDashboard';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import OrderDetail from './pages/OrderDetail';

// Protected Route Component
const ProtectedRoute = ({ children, requireSuperAdmin = false }) => {
  const { isAuthenticated, isSuperAdmin, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requireSuperAdmin && !isSuperAdmin) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Access Denied</div>;
  }

  return children;
};

function AppContent() {
  const { isAuthenticated, isSuperAdmin } = useAuth();

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" />} />

      {/* Order page is public but scoped to a shop */}
      <Route path="/order/:shopId" element={<OrderPage />} />

      {/* Protected Routes */}
      <Route
        path="/register-shop"
        element={
          <ProtectedRoute requireSuperAdmin={true}>
            <ShopRegistration />
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            {isSuperAdmin ? <SuperAdminDashboard /> : <ShopDashboard />}
          </ProtectedRoute>
        }
      />

      <Route
        path="/order-detail/:orderId"
        element={
          <ProtectedRoute>
            <OrderDetail />
          </ProtectedRoute>
        }
      />

      {/* Default Route */}
      <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />

      {/* 404 */}
      <Route path="*" element={<div style={{ padding: '20px', textAlign: 'center' }}>Page Not Found</div>} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <AppContent />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
